import RoofingSection from '../sections/RoofingSection'

const RoofingPage = () => {
    return (
        <div className>
            <RoofingSection />
        </div>
    )
}

export default RoofingPage
